import {useEffect, useRef} from "react";

const useTooltip = (offsetX = 10, offsetY = 10, style = null) => {
    const tooltipRef = useRef(null);

    useEffect(() => {
        tooltipRef.current = document.createElement("div");
        tooltipRef.current.style.position = "fixed";
        tooltipRef.current.style.background = style?.background ?? "rgba(0, 0, 0, 0.75)";
        tooltipRef.current.style.color = style?.color ?? "#fff";
        tooltipRef.current.style.padding = style?.padding ?? "5px 10px";
        tooltipRef.current.style.borderRadius = style?.borderRadius ?? "5px";
        tooltipRef.current.style.fontSize = style?.fontSize ?? "12px";
        tooltipRef.current.style.pointerEvents = "none";
        tooltipRef.current.style.whiteSpace = "nowrap";
        tooltipRef.current.style.zIndex = style?.zIndex ?? 1100;
        tooltipRef.current.style.display = "none";
        document.body.appendChild(tooltipRef.current);

        return () => {
            if (tooltipRef.current) {
                document.body.removeChild(tooltipRef.current);
                tooltipRef.current = null;
            }
        };
    }, []);

    const showTooltip = (content, x, y) => {
        if (tooltipRef.current) {
            tooltipRef.current.innerText = content;
            tooltipRef.current.style.display = "block";
            updatePosition(x, y);
        }
    };

    const updatePosition = (x, y) => {
        if (tooltipRef.current) {
            tooltipRef.current.style.left = `${x + offsetX}px`;
            tooltipRef.current.style.top = `${y + offsetY}px`;
        }
    };

    const hideTooltip = () => {
        if (tooltipRef.current) {
            tooltipRef.current.style.display = "none";
        }
    };

    return { showTooltip, hideTooltip, updatePosition, tooltipRef };
};

export default useTooltip;
